<template>
    <div>
        <p class="title">家庭成员基本信息:</p>
        <van-cell-group>
            <div v-for="(item, index) in person.family" :key="index" class="add">
                <span class="title">姓名:{{item.xm}}</span>
                <van-button type="info" size="small" class="btn" @click="removePeople(item)">删除
                </van-button>
                <van-button type="info" size="small" class="btn" @click="changePeople(index, item,'change')">修改
                </van-button>
            </div>
            <div class="btn-submit-div btn-submit-back">
                <van-button type="info" size="large" @click="addPeople('add')">新增家庭成员</van-button>
            </div>
        </van-cell-group>

        <van-dialog v-model="visitorShow" title="家庭成员添加" show-cancel-button class="van-dialog"
                    :beforeClose="chargeBtn" @cancel="cancelData" @confirm="saveData(visitor)">
            <van-field required clearable v-model="visitor.xm" label="姓名:" placeholder="请输入姓名" input-align="right"/>
            <van-field required readonly clickable label="性别:" v-model="visitor.xbmc" placeholder="请选择"
                       @click="showPickerSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerSex" position="bottom">
                <van-picker show-toolbar :columns="columnsSex" @cancel="showPickerSex = false"
                            value-key="title" @confirm="onConfirmSex"/>
            </van-popup>
            <van-field required clearable v-model="visitor.gmsfhm" label="公民身份证号:"
                       placeholder="请输入公民身份证号" input-align="right"/>
            <van-field required readonly clickable label="与户主关系:" v-model="visitor.ysqrgxmc" placeholder="请选择"
                       @click="showPickerRelation = true" input-align="right" is-link/>
            <van-popup v-model="showPickerRelation" position="bottom">
                <van-picker show-toolbar :columns="list" value-key="title"
                            @cancel="showPickerRelation = false" @confirm="onConfirm"/>
            </van-popup>
        </van-dialog>
    </div>

</template>

<script>
  import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
  import { baseApiMap } from '@/api/base'
  import { idCardRegex, phoneRegex } from '@/utils/regex'
  import { forEachObj } from '@/utils/check'

  export default {
    components: {
      [Button.name]: Button,
      [Toast.name]: Toast,
      [CellGroup.name]: CellGroup,
      [Field.name]: Field,
      [Dialog.name]: Dialog,
      [Dialog.Component.name]: Dialog.Component,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        person: {
          family: [],
          num: 0,
        },
        visitorShow: false, // 是否显示家庭成员信息页面
        attribute: '', // 新增或修改
        visitor: {},// 家庭成员信息对象
        columnsSex: [],
        list: [],
        relation: '',
        showPickerSex: false, // 是否显示性别的选择框
        showPickerRelation: false, // 是否显示与申请人关系的选择框
        index: 0, // 第几个家庭成员
      }
    },
    mounted() {
      // 获取性别
      this.getReservationSex()
      // 获取与申请人关系
      this.getRelation()
    },
    methods: {
      /**
       * 加载性别
       */
      getReservationSex() {
        this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
          let arr = [];
          if (response.data.succ = true) {
            let arrSex = response.data.data;
            for (let i = 0; i < arrSex.length; i++) {
              arr.push({ "title": arrSex[i].title, "val": arrSex[i].val })
            }
          }
          this.$nextTick(() => {
            this.columnsSex = arr
          })
        }).catch(err => {

        })
      },
      /**
       * 获取与拟落户人关系
       */
      getRelation() {
        this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz_gx_docking`).then(res => {
          let arr = [];
          if (res.data.succ = true) {
            arr = res.data.data;
          }
          this.$nextTick(() => {
            this.list = arr
          })
        }).catch(err => {

        })
      },

      /**
       * 新增申请人员
       */
      addPeople(add) {
        this.attribute = add;
        if (this.person.family.length >= this.data.max) {
          this.visitorShow = false
          Toast('抱歉，家庭成员仅限' + this.data.max + '人！')
          return
        }
        this.visitorShow = true;

      },
      /**
       * 删除人员
       */
      removePeople(item) {
        Dialog.confirm({
          title: '提示',
          message: '是否确定删除此项？'
        }).then(async () => {
          //字段过来之后，将这个动态的表单设计成一个对象，每增加一个表单，就将这个对象塞进一个数组，最后将数组传到后台
          const index = this.person.family.indexOf(item)
          if (index !== -1) {
            this.person.family.splice(index, 1)
          }
        }).catch(() => {
        })
      },

      /**
       * 修改人员
       */
      changePeople(index, item, change) {
        this.attribute = change
        this.visitorShow = true
        this.index = index
        // 这样赋值才不会影响原来的数据
        this.visitor = Object.assign({}, item)
        //性别
        for (let k in this.columnsSex) {
          if (this.columnsSex[k].val === item.sex) {
            this.visitor.xbmc = this.columnsSex[k].title
            break
          }
        }

      },
      /**
       * 点击取消/确认按钮完成后触发
       * @param action cancel/confirm
       * @param done
       */
      chargeBtn(action, done) {
        if (action === 'cancel') {//取消按钮
          done();
          return
        } else if (action === 'confirm') {//确定按钮
          //向后端传值并关闭dialog弹出框
          // 在输入框校验成功后弹出框页面关闭，无法在获取输入框属性，在判断弹出框是否可以关闭，不能使用弹出框中的属性
          if (this.visitorShow) {
            done(false);
            return;
          }
          done();
        }
        done();
      },
      /**
       *  取消
       */
      cancelData() {
        this.visitor = {}
        this.hjdz = {}

        this.visitorShow = false
      },
      /**
       *  新增人员
       */
      saveData(data) {
        if (!this.validateForm()) {
          return false
        }

        if (this.attribute === 'add') {
          this.person.family.push(data)
        }
        if (this.attribute === 'change') {
          if (this.index !== -1) {
            // 先删除
            this.person.family.splice(this.index, 1)
            // 再添加
            this.person.family.push(data)
          }
        }
        this.visitor = {}
        this.hjdz = {}
        this.visitorShow = false
      },
      /**
       * 信息校验
       */
      validateForm() {
        forEachObj(this.visitor) // 去掉空格
        if (!this.visitor.xm) {
          Toast('请输入姓名')
          return false
        }
        if (!this.visitor.xbmc) {
          Toast('请选择性别')
          return false
        }
        if (!this.visitor.gmsfhm) {
          Toast('请输入公民身份证号')
          return false
        }
        if (!idCardRegex(this.visitor.gmsfhm)) {
          Toast('公民身份证号输入有误')
          return false
        }
        if (!this.visitor.ysqrgxmc) {
          Toast('请选择与申请人关系')
          return false
        }
        return true
      },
      /**
       * 选择性别
       */
      onConfirmSex(value) {
        this.visitor.xbmc = value.title;
        this.visitor.xb = value.val;
        this.showPickerSex = false
      },
      /**
       * 选择与申请人关系
       */
      onConfirm(value) {
        this.visitor.ysqrgxmc = value.title
        this.visitor.ysqrgx = value.val
        this.showPickerRelation = false
      },
      // 返回家庭成员信息
      setFamilyInfo() {
        let json = {}
        console.log(this.person.family, 'this.person.family')
          let count = this.data.max-this.person.family.length
          let maxlength = this.person.family.length
        for (let i = 0; i < this.person.family.length; i++) {
          json['jtcy' + (i + 1) + '_yhzgx'] = this.person.family[i].ysqrgx
          json['jtcy' + (i + 1) + '_xm'] = this.person.family[i].xm
          // json['jtcy' + (i + 1) + '_yhzgx'] = ''+i
          json['jtcy' + (i + 1) + '_xb'] = this.person.family[i].xb
          json['jtcy' + (i + 1) + '_gmsfhm'] = this.person.family[i].gmsfhm
        }
          if(count>0){
           for(let i=0;i<count;i++){
               maxlength++
               json['jtcy' + maxlength + '_xm'] = ""
               json['jtcy' + maxlength + '_yhzgx'] = ""
               json['jtcy' + maxlength + '_xb'] = ""
               json['jtcy' + maxlength + '_gmsfhm'] = ""
           }
          }
        json['sqly'] = '' // 申请理由
        this.data.family = json
        this.data.familyList = this.person.family
        this.data.num = this.person.family.length
      }
    }
  }
</script>

<style scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }

    .btn {
        float: right;
        width: 22%;
        line-height: 30px;
        margin-right: 2%;
        font-size: 15px;
        margin-top: 0.5%
    }

    .add {
        line-height: 0.8rem;
        padding: 0.2rem 0px 0.2rem 0;
        box-sizing: border-box;
    }

    .van-dialog {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        overflow: auto;
        font-size: 16px;
        background-color: #fff;
        border-radius: 4px;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: .3s;
        transition: .3s;
    }
</style>
